// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__GwATO","tooltip--light":"Tooltip_tooltip--light__HdPas"};